<template>
    <footer class="footer hidden-xs-down">
        <p>
            Made with <i class="zmdi zmdi-favorite"></i> by ABOnline solutions for <a :href="companyURL">{{ company }}</a> © 2018
        </p>
    </footer>
</template>

<script>
    import AppHelper from "../helper";

    export default {
        computed: {
            company() {
                if(!AppHelper.empty(process.env.TARGET_COMPANY)){
                    return process.env.TARGET_COMPANY
                }

                return 'Initiative'
            },

            companyURL() {
                if(!AppHelper.empty(process.env.TARGET_COMPANY_URL)){
                    return process.env.TARGET_COMPANY_URL
                }

                return 'https://www.initiative-crm.com/rgpd-crm-donnees-personnelles/'
            }
        },
    }
</script>

<style lang="scss">
    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/layout/Footer.vue